import StudentInformanceMain from "Pages/StudentPortfolio/StudentPerfomanceSection/StudentInformance/StudentInformanceMain";
import "./index.css";
import RightArrow from "Assets/Icons/RightArrow";
import AddNewComponentFooter from "Pages/StudentPortfolio/StudentPortfolioMobile/AddNewComponentFooter";
import StudentPortfolioSlider from "Pages/StudentPortfolio/StudentPortfolioMobile/StudentPortfolioSlider";
import { useContext, useEffect, useState } from "react";
import StudentCommentSection from "Pages/StudentPortfolio/StudentCommentSection/StudentCommentSection";
import { UserInfoContext } from "Context/CommonContext";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
const StudentPortfolioMainMobile = ({
  tabs,
  selectedStudent,
  commentsObj,
  setCommentsObj,
}: any) => {
  const [isPaneOpen, setisPaneOpen] = useState<boolean>(false);
  const [isPaneOpenComment, setIsPaneOpenComment] = useState(false);
  const [component, setComponent] = useState<any>("");
  const userInfo = useContext<any>(UserInfoContext);

  useEffect(() => {
    if (component && component.label) {
      pushToDataLayerForGTM({
        event: "ag_sp_student_performace_viewed",
        PSID: String(selectedStudent?.psid),
        USER_ROLE: userInfo?.fexRole,
        TAB_NAME: component.label,
      });
      pushToDataLayerForGTM({
        event: "ag_sp_view_student_performance_tab",
        PSID: String(selectedStudent?.psid),
        STUDENT_NAME: selectedStudent?.name,
        TAB_NAME: component.label,
      });
    }
  }, [component, selectedStudent, userInfo]);

  const paneOpenCommentToggle = () => {
    setIsPaneOpenComment(!isPaneOpenComment);
  };
  const addCommentHandler = () => {
    paneOpenCommentToggle();
  };
  const viewCommentHandler = () => {
    paneOpenCommentToggle();
  };
  const toggle = () => {
    setisPaneOpen(!isPaneOpen);
  };
  const selectListHandler = (ele: any) => {
    toggle();
    setComponent(ele);
  };
  const selectStudentDetailHandler = () => {
    const StudentDetailTab = tabs.find(
      (item: any) => item.label == "Student Details"
    );
    toggle();
    setComponent(StudentDetailTab);
  };
  return (
    <div className="mobileViewMainRow">
      <StudentPortfolioSlider
        commentsObj={commentsObj}
        isPaneOpen={isPaneOpen}
        setisPaneOpen={setisPaneOpen}
        onRequestClose={toggle}
        addCommentHandler={addCommentHandler}
        viewCommentHandler={viewCommentHandler}
        tabs={tabs}
        component={component}
        setComponent={setComponent}
      >
        {component.component}
      </StudentPortfolioSlider>
      <div>
        <StudentInformanceMain
          selectStudentDetailHandler={selectStudentDetailHandler}
          selectedStudent={selectedStudent}
        />
      </div>
      <div className="p-0 tabsDiv mb-5">
        {tabs.map((ele: any, index: number) => {
          return (
            <div
              key={index}
              className={"studentPortfolioDiv"}
              onClick={() => {
                selectListHandler(ele);
              }}
            >
              <div className="d-flex">
                <span className="ml-2">{ele?.label}</span>
              </div>
              <div>
                <RightArrow />
              </div>
            </div>
          );
        })}
      </div>
      <StudentCommentSection
        commentsObj={commentsObj}
        setCommentsObj={setCommentsObj}
        isPaneOpen={isPaneOpenComment}
        setIsPaneOpen={setIsPaneOpenComment}
        isPaneOpenComment={isPaneOpenComment}
      ></StudentCommentSection>
      <div>
        <AddNewComponentFooter
          selectedStudent={selectedStudent}
          commentsObj={commentsObj}
          addCommentHandler={addCommentHandler}
          viewCommentHandler={viewCommentHandler}
        />
      </div>
    </div>
  );
};
export default StudentPortfolioMainMobile;
